// Add Product Button Component
function AddProductButton() {
    return (
        <div className="flex flex-col space-y-1">
            <button
                type="button"
                className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
                Add Product
            </button>
        </div>
    );
}

export default AddProductButton;